import { Box, Divider, Grid, Link, List, Typography } from '@mui/material'
import styles from 'components/Sell/payment/paymentDialog.style'
import { useTranslation } from 'react-i18next'
import PaymentDetailRow from './PaymentDetailRow'
import { useFormat } from 'Services/localize/format'
import Delete from '@mui/icons-material/Delete'
import { useMemo } from 'react'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { usePaymentCalculation } from 'components/Sell/payment/hook/usePaymentCalculation'
import MonetaryFormat from 'components/MonetaryFormat/MonetaryFormat'
import { PAYMENT_TYPE_ID } from 'constant/paymentType'
import { mapPaymentTypeName } from 'components/MapPaymentIcon/mapPaymentIcon'

function PaymentMobileDetail() {
    const { t } = useTranslation()
    const { currency, currencyCode } = useFormat()
    const {
        selectedPaymentType,
        expectAmount,
        payment,
        tenderedAmount,
    } = usePaymentContext()
    const {
        balanceDueAmount,
        cashRoundingAdjustAmount,
        collectValue,
        changeValue,
    } = usePaymentCalculation({
        selectedPaymentType,
        expectAmount,
        payment,
    })
    const showCashRoundingAdjust = useMemo(
        () => !cashRoundingAdjustAmount.equals(0),
        [cashRoundingAdjustAmount],
    )
    const showTips = false
    const paymentSettingName = useMemo(
        () =>
            mapPaymentTypeName(selectedPaymentType?.paymentTypeID, true, {
                paymentSetting: selectedPaymentType,
            }),
        [selectedPaymentType],
    )

    return (
        <Grid
            container
            // sx={{ ...styles.background }}
            direction="column"
            alignItems="stretch"
        >
            <List dense>
                <PaymentDetailRow
                    label={t('finish.label.currency') + ':'}
                    value={currencyCode}
                    isBold
                    highlightValue
                />

                <PaymentDetailRow
                    label={t('finish.label.total_due') + ':'}
                    value={`${currency(expectAmount.toNumber())}`}
                />

                {showCashRoundingAdjust && (
                    <>
                        <PaymentDetailRow
                            label="Balance due:"
                            value={`${currency(balanceDueAmount.toNumber())}`}
                        />
                        <PaymentDetailRow
                            label="Cash rounding:"
                            value={
                                <MonetaryFormat
                                    color={
                                        cashRoundingAdjustAmount.greaterThan(-1)
                                            ? 'textPrimary'
                                            : 'error'
                                    }
                                    sx={styles.detailTextFont}
                                    value={cashRoundingAdjustAmount.toNumber()}
                                />
                            }
                        />
                    </>
                )}

                <PaymentDetailRow
                    label={t('finish.label.collect') + ':'}
                    value={`${currency(collectValue.toNumber())}`}
                />

                <PaymentDetailRow
                    label={`${paymentSettingName}:`}
                    value={`${currency(tenderedAmount.toNumber())}`}
                />

                {selectedPaymentType?.paymentTypeID ===
                    PAYMENT_TYPE_ID.CASH && (
                    <>
                        <Divider variant="middle" component="li" />
                        <PaymentDetailRow
                            label={t('finish.label.change') + ':'}
                            value={
                                <MonetaryFormat
                                    color={
                                        changeValue.greaterThan(-1)
                                            ? 'textPrimary'
                                            : 'error'
                                    }
                                    sx={styles.detailTextFont}
                                    value={changeValue.toNumber()}
                                />
                            }
                            isBold
                        />
                    </>
                )}
                {showTips && (
                    <PaymentDetailRow
                        label={
                            <Box display="flex" alignItems="center">
                                Tip
                                <Link
                                    color="secondary"
                                    onClick={() => {}}
                                    sx={{ cursor: 'pointer' }}
                                >
                                    <Typography
                                        className="textUpper"
                                        variant={'subtitle2'}
                                    >
                                        <Delete
                                            fontSize="small"
                                            sx={{
                                                mb: '-5px',
                                                mr: '3px',
                                            }}
                                        />
                                        {t('finish.button.remove_tip')}
                                    </Typography>
                                </Link>
                            </Box>
                        }
                        value={`${currency(10)}`}
                    />
                )}
            </List>
        </Grid>
    )
}
export default PaymentMobileDetail
